import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { generateCodeVerifier, checkCode } from "@/util/utils";
import { resetPwdByCode, sendPwdCode, getLoginConfig as _getLoginConfig } from "@/api/login";
import request from "@/util/http";
export default {
  name: "ForgetPassword",
  components: {},
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      getConfig: {},
      isCodeing: false,
      count: 0,
      username: "",
      loading: false,
      requesting: false,
      formInline: {
        password: "",
        code: ""
      },
      rules: {
        password: [{
          min: 6,
          max: 20,
          message: "长度在 6 到 20 个字符",
          trigger: "change"
        }]
      },
      codeDialog: false,
      randomStr: "",
      //验证码
      code: ""
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.initCode();
    this.getLoginConfig();
  },
  methods: {
    submitForm: function submitForm() {
      var _this = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this.resetPwdByCodeHandle();
        }
      });
    },
    resetPwdByCodeHandle: function resetPwdByCodeHandle() {
      var _this2 = this;

      this.requesting = true;
      resetPwdByCode(_objectSpread(_objectSpread({}, this.formInline), {}, {
        secPassword: this.formInline.password,
        username: this.username
      })).then(function (_ref) {
        var data = _ref.data;
        _this2.requesting = false;

        if (data.code == 0) {
          _this2.$message.success("修改密码成功，3秒后跳入登录页");

          setTimeout(function () {
            _this2.$router.push("/login");
          }, 3000);
        } else {
          _this2.$message.warning(data.msg || "修改密码失败!");
        }
      }).catch(function (err) {
        _this2.requesting = false;
      });
    },
    sendPwdCodeHandle: function sendPwdCodeHandle() {
      this.codeDialog = true; // return
      //   sendPwdCode(this.username).then(({data})=>{
      //       if(data.code==0){
      //           this.getVerifyCode();
      //           this.formInline.userId=data.data.userId;
      //       }else{
      //           this.$message.warning(data.msg||'短信发送失败!');
      //       }
      //   }).catch(err=>{
      //   })
    },
    getVerifyCode: function getVerifyCode() {
      var _this3 = this;

      var TIME_COUNT = 60;

      if (!this.timer) {
        this.count = TIME_COUNT;
        this.isCodeing = true;
        this.timer = setInterval(function () {
          if (_this3.count > 0 && _this3.count <= TIME_COUNT) {
            _this3.count--;
          } else {
            _this3.isCodeing = false;
            clearInterval(_this3.timer);
            _this3.timer = null;
          }
        }, 1000);
      }
    },
    getLoginConfig: function () {
      var _getLoginConfig2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, faviconLink;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _getLoginConfig();

              case 2:
                res = _context.sent;
                res.data.data.isOpenCassso == "1" ? res.data.data.isOpenCassso = true : res.data.data.isOpenCassso = false;
                res.data.data.middlePage == "1" ? res.data.data.middlePage = true : res.data.data.middlePage = false;
                res.data.data.phone == "1" ? res.data.data.phone = true : res.data.data.phone = false;
                res.data.data.mobileOrPc == "1" ? res.data.data.mobileOrPc = true : res.data.data.mobileOrPc = false;
                this.phoneBlo = res.data.data.phone;
                this.getConfig = res.data.data;
                window.sessionStorage.setItem("setConfig", JSON.stringify(this.getConfig));
                faviconLink = document.querySelector("#faviconLink");

                if (faviconLink) {
                  faviconLink.setAttribute("href", this.getConfig.favicon);
                }

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getLoginConfig() {
        return _getLoginConfig2.apply(this, arguments);
      }

      return getLoginConfig;
    }(),
    initCode: function initCode() {
      this.randomStr = generateCodeVerifier(5);
    },
    handleClose: function handleClose() {
      this.code = "";
    },
    codeSubmit: function codeSubmit() {
      var _this4 = this;

      checkCode("/check?code=".concat(this.code, "&randomStr=").concat(this.randomStr)).then(function (res) {
        if (res.data.success) {
          _this4.seedCodeHandle();
        } else {
          _this4.$Notify({
            type: "danger",
            message: res.data.msg
          });
        }
      });
    },
    seedCodeHandle: function seedCodeHandle() {
      var _this5 = this;

      request({
        url: "/admin/mobile/sendPwdCode/".concat(this.username, "?code=").concat(this.code, "&randomStr=").concat(this.randomStr),
        method: "get"
      }).then(function (res) {
        console.log(res);

        if (res.data.success) {
          _this5.codeDialog = false;

          _this5.getVerifyCode();
        }
      });
    }
  },
  destroyed: function destroyed() {},
  filters: {}
};